import React from 'react';
import {
  Activity,
  AlertCircle,
  AlertOctagon,
  AlertTriangle,
  Archive,
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  ArrowUpDown,
  BadgeCheck,
  Ban,
  BarChart3,
  Beef,
  Bell,
  BellRing,
  BookOpen,
  Bookmark,
  Bot,
  Briefcase,
  Cake,
  Calculator,
  Calendar,
  CalendarCheck,
  CalendarDays,
  Check,
  CheckCircle,
  CheckCircle2,
  CheckSquare,
  ChefHat,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  Circle,
  CircleSlash,
  ClipboardCheck,
  ClipboardList,
  ClipboardPlus,
  Clock,
  Coffee,
  Cookie,
  Copy,
  CornerDownRight,
  CreditCard,
  Crown,
  DollarSign,
  Download,
  Edit,
  Edit2,
  EllipsisVertical,
  ExternalLink,
  Eye,
  FileSpreadsheet,
  FileText,
  FileUp,
  Filter,
  Flame,
  FlaskConical,
  Globe,
  GraduationCap,
  Grid3X3,
  Heart,
  HeartOff,
  FolderOpen,
  HelpCircle,
  History,
  Home,
  IceCream,
  IdCard,
  Info,
  Key,
  LayoutDashboard,
  LifeBuoy,
  Lightbulb,
  Link,
  Link2,
  List,
  ListChecks,
  ListRestart,
  Loader,
  Loader2,
  Lock,
  LogIn,
  LogOut,
  Mail,
  MapPin,
  Maximize2,
  Menu,
  MessageCircle,
  MessageSquare,
  Minus,
  Moon,
  Navigation,
  PartyPopper,
  Phone,
  Pizza,
  PlugZap,
  Plus,
  Power,
  Receipt,
  ReceiptText,
  RefreshCcw,
  RefreshCw,
  Rocket,
  RotateCcw,
  Salad,
  Save,
  School,
  Search,
  Send,
  Settings,
  Share,
  Share2,
  Shield,
  ShieldCheck,
  ShoppingBag,
  ShoppingCart,
  Slash,
  Sparkles,
  SplitSquareHorizontal,
  Star,
  StickyNote,
  Store,
  Tag,
  Timer,
  Trash,
  Trash2,
  TrendingDown,
  TrendingUp,
  Trophy,
  Truck,
  Upload,
  User,
  UserPlus,
  UserRound,
  Users,
  Utensils,
  UtensilsCrossed,
  Vote,
  WalletCards,
  Wallet,
  X,
  XCircle,
} from 'lucide-react';

const iconRegistry = {
  Activity,
  AlertCircle,
  AlertOctagon,
  AlertTriangle,
  Archive,
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  ArrowUpDown,
  BadgeCheck,
  Ban,
  BarChart3,
  Beef,
  Bell,
  BellRing,
  BookOpen,
  Bookmark,
  Bot,
  Briefcase,
  Cake,
  Calculator,
  Calendar,
  CalendarCheck,
  CalendarDays,
  Cart: ShoppingCart,
  Check,
  CheckCircle,
  CheckCircle2,
  CheckSquare,
  ChefHat,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  Circle,
  CircleSlash,
  ClipboardCheck,
  ClipboardList,
  ClipboardPlus,
  Clock,
  Coffee,
  Cookie,
  Copy,
  CornerDownRight,
  CreditCard,
  Crown,
  DollarSign,
  Download,
  Edit,
  Edit2,
  EllipsisVertical,
  ExternalLink,
  Eye,
  FileSpreadsheet,
  FileText,
  FileUp,
  Filter,
  Flame,
  FlaskConical,
  Globe,
  GraduationCap,
  Grid3X3,
  Heart,
  HeartOff,
  FolderOpen,
  HelpCircle,
  History,
  Home,
  IceCream,
  IdCard,
  Info,
  Key,
  LayoutDashboard,
  LifeBuoy,
  Lightbulb,
  Link,
  Link2,
  List,
  ListChecks,
  ListRestart,
  Loader,
  Loader2,
  Lock,
  LogIn,
  LogOut,
  Mail,
  MapPin,
  Maximize2,
  Menu,
  MessageCircle,
  MessageSquare,
  Minus,
  Moon,
  MoreVertical: EllipsisVertical,
  Navigation,
  PartyPopper,
  Pepper: Flame,
  Phone,
  Pizza,
  PlugZap,
  Plus,
  Power,
  Receipt,
  ReceiptText,
  RefreshCcw,
  RefreshCw,
  Rocket,
  RotateCcw,
  Salad,
  Save,
  School,
  Search,
  Send,
  Settings,
  Share,
  Share2,
  Shield,
  ShieldCheck,
  ShoppingBag,
  ShoppingCart,
  Slash,
  Sparkles,
  SplitSquareHorizontal,
  Star,
  Stars: Sparkles,
  StickyNote,
  Store,
  Tag,
  Timer,
  Trash,
  Trash2,
  TrendingDown,
  TrendingUp,
  TriangleAlert: AlertTriangle,
  Trophy,
  Truck,
  Upload,
  User,
  UserPlus,
  UserRound,
  Users,
  Utensils,
  UtensilsCrossed,
  Vote,
  WalletCards,
  Wallet,
  X,
  XCircle,
  Bowl: Utensils,
};

function Icon({
    name,
    size = 24,
    color = "currentColor",
    className = "",
    strokeWidth = 2,
    ...props
}) {
    const IconComponent = typeof name === 'string' ? iconRegistry[name] : null;

    if (!IconComponent) {
        return <HelpCircle size={size} color="gray" strokeWidth={strokeWidth} className={className} {...props} />;
    }

    return <IconComponent
        size={size}
        color={color}
        strokeWidth={strokeWidth}
        className={className}
        {...props}
    />;
}
export default Icon;
